import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';

@Component({
    selector: 'noos-textbox',
    templateUrl: './textbox.component.html',
    styleUrls: ['./textbox.component.scss']
})
@NoosFormTypeService.register('text')
export class TextboxComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    isFilter = false;
    thisAppearance: any = 'outline';

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    constructor() {
    }

    ngOnInit() {

    }


    ngAfterViewInit(): void {
        if (this.isFilter) {
            this.prop.requared = false;
        }
    }


    onKeydown($event: any) {
        this.keyOnEnter.emit();
    }
}
